module.exports = __webpack_public_path__ + "img/icon-riser.9dcfcad0.svg";